import {post} from "@/axios/request";

export const getPriorProjectList = (page, size, data) => {
  return post("/service/api/client/getPriorProjectList",
    {
      page,
      size,
      ...data
    }
  )
}

export const getPriorProjectListByItemCode = (page, size, data) => {
  return post("/service/api/client/getPriorProjectListByItemCode",     {
    page,
    size,
    ...data
  })
}

export const getPriorProjectInfo = data => {
  return post("/service/api/client/getPriorProjectInfo", data)
}

export const getPriorRuleInfo = data => {
  return post("/service/api/client/getPriorRuleInfo", data)
}

export const submitRPriorBusi = data => {
  return post("/service/api/client/submitRPriorBusi", data)
}

export const getProjectNameCount = (page, size, data) => {
  return post("/archive/archive/project/getProjectNameCount", {
    page,
    size,
    ...data
  })
}

export const getProjectList = (page, size, data) => {
  return post("/archive/archive/project/getProjectList", {
    page,
    size,
    ...data
  })
}
